<div ng-if="dashboard.countryCode === 'hr'" class="banner-image-url"
     ng-style="{'background-image': 'url(' + dashboard.bannerImageUrl + ')'}">
  <div class="t-a-l" style="position:absolute; bottom: 0px; top:0px; left: 35px;">
      <h3 class="c-white fw-cl custom-underline" ng-if="dashboard.currentLang == 'hr'"  style="">{{APP_GLOBAL_SETTINGS.defaultData.MarketingInfo.text1}}</h3>
      <h3 class="c-white fw-cl custom-underline" ng-if="dashboard.currentLang == 'en'"  style="">{{APP_GLOBAL_SETTINGS.defaultData.MarketingInfo.textEng1}}</h3>
      <h3 class="c-white fw-cl custom-underline pull-left m-0" ng-if="dashboard.currentLang == 'hr'">{{APP_GLOBAL_SETTINGS.defaultData.MarketingInfo.text2}}</h3>
      <h3 class="c-white fw-cl custom-underline pull-left m-0" ng-if="dashboard.currentLang == 'en'">{{APP_GLOBAL_SETTINGS.defaultData.MarketingInfo.textEng2}} </h3>

      <!--<h4 class="bold-font c-white" ng-if="dashboard.currentLang == 'en'">{{APP_GLOBAL_SETTINGS.defaultData.MarketingInfo.textEng2}} </h4>-->
        <!--<button type="button" class="btn btn-default text-uppercase" style="background-color: #062a42">-->
            <!--<a ng-href="https://www.addiko.hr/addiko-blic-kredit" target="_blank"  translate="dashboard.apply"></a>-->
        <!--</button>-->
      <div style="position: absolute; bottom: 10px" ng-click="dashboard.pushGtmLinkEvent('Banner ' + APP_GLOBAL_SETTINGS.defaultData.MarketingInfo.link);">
      <button data-ng-click="dashboard.goToMarketingLinkCro()" target="_blank"
         class="btn btn-default text-uppercase round-marketing-button" style="background-color: #062a42;line-height: 2.6;" >
        <span class="glyphicon glyphicon-chevron-right round-marketing-icon" aria-hidden="true"></span>
        <span class="round-marketing-text" translate="dashboard.info"></span>
      </button>
    </div>

    </div>
</div>

<div ng-if="dashboard.countryCode === 'bh'" ng-click="dashboard.pushGtmLinkEvent('Reklamni banner');">
  <a href="{{APP_GLOBAL_SETTINGS.defaultData.MarketingInfo.link}}" target="_blank">
    <div style="height: 161px; background-color: #ff4d5a; background-size: auto 100%; background-repeat: no-repeat;" ng-style="{'background-image': 'url(' + dashboard.bannerImageUrl + ')'}">
    </div>
  </a>
</div>

<div ng-if="dashboard.countryCode === 'sr'" ng-click="dashboard.pushGtmLinkEvent('Banner - Kredit za refinansiranje');">
    <a href="https://www.addiko.rs/kredit-za-refinansiranje?utm_source=digitalbanking&utm_medium=banner&utm_campaign=kesref_2016" target="_blank">
        <div style="height: 161px; background-color: #ff4d5a; background-size: auto 100%; background-repeat: no-repeat;" ng-style="{'background-image': 'url(' + dashboard.bannerImageUrl + ')'}">
        </div>
    </a>
</div>

<div ng-if="dashboard.countryCode === 'mne'" ng-click="dashboard.pushGtmLinkEvent('Banner - Restart kredit');">
  <a href="https://www.addiko.me/restart-kredit-0" target="_blank">
    <div style="height: 161px; background-color: #ff4d5a; background-size: auto 100%; background-repeat: no-repeat;" ng-style="{'background-image': 'url(' + dashboard.bannerImageUrl + ')'}">
    </div>
  </a>
</div>

<div ng-if="dashboard.countryCode === 'sl'" style='height: 161px; background-position: center; background-size: cover;background-color: #ff4d5a;background-image: url("img/hypo/addiko-klub.png");' class="pointer-cst" ng-click="dashboard.openAddikoClubSl();">
    <div class="p-20">
        <h3 class="c-white m-t-0 m-b-30"><b class="col-xs-12 p-0 f-30 no-wrap-text">Addiko klub</b></h3>
        <div style="padding-top: 13px">

            <amount-formatter amount="{{dashboard.loyaltyPointsResult.loyaltyCurrentPoints|number:2}}" custom-classes="{{'c-white'}}" currency="{{'dashboard.loyaltyCurrentPoints' | translate}}" from-type="dashboard" aditional-val="" has-underline="true">
            </amount-formatter>
            <amount-formatter amount="{{dashboard.loyaltyPointsResult.loyaltyPreviousPoints|number:2}}" custom-classes="{{'c-blue'}}" currency="{{'dashboard.loyaltyPreviousPoints' | translate}}" from-type="addikoKlub" aditional-val="" has-underline="false">
            </amount-formatter>
        </div>

    </div>
</div>
